import { raw, type SafeHtml } from 'kerfjs';

import { renderMarkdown } from '../../../lib/markdown.js';

export function MessageMarkdown({ text }: { text: string }): SafeHtml {
  // renderMarkdown escapes source HTML before adding its small safe markup set.
  // eslint-disable-next-line kerfjs/no-raw-with-dynamic-arg
  return <div class="message-markdown">{raw(renderMarkdown(text))}</div>;
}
